import { VOMedia, VOMediaType } from "../model/DataStructure.js";
import { MediaContent, MediaContentOptions } from "./MediaContent.js";

export interface MediaImageOptions extends MediaContentOptions {

}

export class MediaImage extends MediaContent<MediaImageOptions>{

    public readonly type: VOMediaType = "image";

    private _content: HTMLImageElement;

    constructor(options: MediaImageOptions) {
        super(options);

        this._element.classList.add("media-image");

        this._content = document.createElement("img");
        this._content.className = "media-content__content media-image__content";
        this._body.appendChild(this._content);

        this._content.addEventListener("load", () => {
            this.onReady.dispatch();
        });
    }

    protected getAspectRatio(data: VOMedia): number | null {
        if (!data.image) {
            return null;
        }
        return data.image.width / data.image.height;
    }

    public load(data: VOMedia): void {
        this.onLoad.dispatch();

        this._content.style.aspectRatio = `${data.image.width} / ${data.image.height}`;
        this._content.src = data.image?.url || "";
        this.caption = data.caption || "";
    }
}